export const VIDEO_PLAYER_V2 =
  document.documentElement.dataset.videoPlayerV2 === "true";

export const LESSON_COMPLETION =
  document.documentElement.dataset.lessonCompletion === "true";
